import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

interface GetInvestmentTypesHookType {
  enabled?: boolean;
}

export default function useGetInvestmentTypes({
  enabled = true,
}: GetInvestmentTypesHookType = {}) {
  return useQuery({
    queryKey: ["investment-types"],
    queryFn: async () => {
      return axiosInstance.get("/investment-types").then((res) => res.data);
    },
    retry: false,
    enabled,
    staleTime: 1000 * 60 * 5, 
  });
}
